export const toTitleCase = s => {
  if (!s) {
    return ''
  }
  return s[0].toUpperCase() + s.slice(1)
}

export const isString = x =>
  Object.prototype.toString.call(x) === '[object String]'
